module.exports = __webpack_public_path__ + "static/media/waves.cb7c7566.jpg";